import styled from "styled-components";

export const Container = styled.div`
	position: absolute;
	display: flex;
	justify-content: left;
	align-items: center;
	font-size: 0.82em;
	top: 22%;
	left: 49.5%;
	width: 25.3em;
	height: 5em;
	transform: translateX(-50%);

	@media (min-width: 650px) {
		justify-content: center;
		top: 20%;
		left: 2.4%;
		width: 35em;
		transform: unset;
		height: 19em;
	}
`;

export const Circle = styled.div<{ $backgroundImage: string }>`
	position: absolute;
	font-size: 0.74em;
	background-image: url(${(props) => props.$backgroundImage});
	background-size: contain;
	top: 36%;
	right: 5.5%;
	transform: translateY(-50%);
	border-radius: 50%;
	padding: 0.5em 0.5em;
	gap: 0.5rem;
	box-sizing: border-box;
	height: auto;
	z-index: 999;
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	width: 8.5em;
	height: 8.5em;

	@media (min-width: 650px) {
		font-size: 0.96em;
		right: unset;
		top: 49%;
	}
`;

export const RewardContainer = styled.div`
	position: absolute;
	bottom: 1em;
	justify-content: center;
	align-items: center;
	display: flex;
	height: 75%;
`;

export const RewardItem = styled.div<{ width?: string }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
`;

export const ItemImage = styled.img`
	object-fit: contain;
	justify-self: center;
	align-self: center;
	width: 100%;
	height: 5.2em;
`;

export const Text = styled.div`
	-webkit-text-stroke-width: 0.19em;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	color: #fff;
	font-weight: 400;
	font-family: Baloo;
`;

export const EarnedText = styled(Text)`
	position: absolute;
	font-size: 1.42em;
	text-align: left;
	line-height: 1.06em;
	max-width: 68%;
	max-height: 3.5em;
	bottom: 5.4%;
	letter-spacing: 0.02em;

	@media (min-width: 650px) {
		font-size: 1.8em;
		text-align: center;
		line-height: 1em;
		max-width: 100%;
	}
`;

export const Span = styled.span`
	display: inline;
	white-space: unset;
	@media (min-width: 650px) {
		display: block;
		white-space: nowrap;
	}
`;
